import IncomingSmsDisplay from './IncomingSmsDisplay.container'
import IncomingSmsForm from './IncomingSmsForm.container'
import IconCellMessage from 'components/Icons/CellMessage'
import { getNumberType } from '../../utils/getNumberType'
import { get } from 'lodash'

export default {
  id: 'incoming_sms',
  label: 'Incoming SMS',
  helpUrl: 'https://help.thinkpickle.com.au/flows/triggers/incoming-sms',
  icon: IconCellMessage,
  inputs: [],
  outputs: [{}],
  display: IncomingSmsDisplay,
  form: IncomingSmsForm,
  getPriceId: node => {
    const numberType = getNumberType(get(node, 'extras.number', ''))
    if (numberType === 'tollFree') {
      return 'receiveTollFreeCall'
    } else if (numberType === 'mobile') {
      return 'receiveMobileCall'
    } else if (numberType === 'local') {
      return 'receiveLocalCall'
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingSms/index.js